export default {"src":"/_next/static/media/ROST.7ca78b29.svg","height":18,"width":18};